import { useEffect, useMemo } from 'react';
import { useColumnsOrderLocalStorageState } from '../localStorage/useLocalStorageKeys';
const getColumnOrder = (mappedColums) => mappedColums.map((column) => column.fieldName);
export const useColumnOrder = (tableKey, columns) => {
    const [columnOrder, setColumnOrder] = useColumnsOrderLocalStorageState(tableKey, getColumnOrder(columns));
    const columOrderWithIndex = useMemo(() => {
        if (!columnOrder.includes('index')) {
            return ['index', ...columnOrder];
        }
        return columnOrder;
    }, [columnOrder]);
    useEffect(() => {
        const fieldNames = columns.map((column) => column.fieldName);
        setColumnOrder((prev) => {
            const missingFields = fieldNames.filter((fieldName) => !prev.includes(fieldName));
            return [...prev, ...missingFields];
        });
    }, [columns, setColumnOrder]);
    return { columnOrder: columOrderWithIndex, setColumnOrder };
};
//# sourceMappingURL=useColumnOrder.js.map